/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3233927aa82734f9$var$t = globalThis, $3233927aa82734f9$export$b4d10f6001c083c2 = $3233927aa82734f9$var$t.ShadowRoot && (void 0 === $3233927aa82734f9$var$t.ShadyCSS || $3233927aa82734f9$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $3233927aa82734f9$var$s = Symbol(), $3233927aa82734f9$var$o = new WeakMap;
class $3233927aa82734f9$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $3233927aa82734f9$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($3233927aa82734f9$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $3233927aa82734f9$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $3233927aa82734f9$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $3233927aa82734f9$export$8d80f9cac07cdb3 = (t)=>new $3233927aa82734f9$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $3233927aa82734f9$var$s), $3233927aa82734f9$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $3233927aa82734f9$export$505d1e8739bad805(o, t, $3233927aa82734f9$var$s);
}, $3233927aa82734f9$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($3233927aa82734f9$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $3233927aa82734f9$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $3233927aa82734f9$export$ee69dfd951e24778 = $3233927aa82734f9$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $3233927aa82734f9$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $27fcf98b67c2a783$var$i, defineProperty: $27fcf98b67c2a783$var$e, getOwnPropertyDescriptor: $27fcf98b67c2a783$var$r, getOwnPropertyNames: $27fcf98b67c2a783$var$h, getOwnPropertySymbols: $27fcf98b67c2a783$var$o, getPrototypeOf: $27fcf98b67c2a783$var$n } = Object, $27fcf98b67c2a783$var$a = globalThis, $27fcf98b67c2a783$var$c = $27fcf98b67c2a783$var$a.trustedTypes, $27fcf98b67c2a783$var$l = $27fcf98b67c2a783$var$c ? $27fcf98b67c2a783$var$c.emptyScript : "", $27fcf98b67c2a783$var$p = $27fcf98b67c2a783$var$a.reactiveElementPolyfillSupport, $27fcf98b67c2a783$var$d = (t, s)=>t, $27fcf98b67c2a783$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $27fcf98b67c2a783$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $27fcf98b67c2a783$export$53a6892c50694894 = (t, s)=>!$27fcf98b67c2a783$var$i(t, s), $27fcf98b67c2a783$var$y = {
    attribute: !0,
    type: String,
    converter: $27fcf98b67c2a783$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $27fcf98b67c2a783$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $27fcf98b67c2a783$var$a.litPropertyMetadata ??= new WeakMap;
class $27fcf98b67c2a783$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $27fcf98b67c2a783$var$y) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
            void 0 !== r && $27fcf98b67c2a783$var$e(this.prototype, t, r);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: h } = $27fcf98b67c2a783$var$r(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get () {
                return e?.call(this);
            },
            set (s) {
                const r = e?.call(this);
                h.call(this, s), this.requestUpdate(t, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $27fcf98b67c2a783$var$y;
    }
    static _$Ei() {
        if (this.hasOwnProperty($27fcf98b67c2a783$var$d("elementProperties"))) return;
        const t = $27fcf98b67c2a783$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($27fcf98b67c2a783$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($27fcf98b67c2a783$var$d("properties"))) {
            const t = this.properties, s = [
                ...$27fcf98b67c2a783$var$h(t),
                ...$27fcf98b67c2a783$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $3233927aa82734f9$export$ee69dfd951e24778)(s));
        } else void 0 !== s && i.push((0, $3233927aa82734f9$export$ee69dfd951e24778)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $3233927aa82734f9$export$2ca4a66ec4cecb90)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$EC(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const r = (void 0 !== i.converter?.toAttribute ? i.converter : $27fcf98b67c2a783$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), r = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $27fcf98b67c2a783$export$7312b35fbf521afb;
            this._$Em = e, this[e] = r.fromAttribute(s, t.type), this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            if (i ??= this.constructor.getPropertyOptions(t), !(i.hasChanged ?? $27fcf98b67c2a783$export$53a6892c50694894)(this[t], s)) return;
            this.P(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$ET());
    }
    P(t, s, i) {
        this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && (this._$Ej ??= new Set).add(t);
    }
    async _$ET() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t)!0 !== i.wrapped || this._$AL.has(s) || void 0 === this[s] || this.P(s, this[s], i);
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EU();
        } catch (s) {
            throw t = !1, this._$EU(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EU() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Ej &&= this._$Ej.forEach((t)=>this._$EC(t, this[t])), this._$EU();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$27fcf98b67c2a783$export$c7c07a37856565d.elementStyles = [], $27fcf98b67c2a783$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $27fcf98b67c2a783$export$c7c07a37856565d[$27fcf98b67c2a783$var$d("elementProperties")] = new Map, $27fcf98b67c2a783$export$c7c07a37856565d[$27fcf98b67c2a783$var$d("finalized")] = new Map, $27fcf98b67c2a783$var$p?.({
    ReactiveElement: $27fcf98b67c2a783$export$c7c07a37856565d
}), ($27fcf98b67c2a783$var$a.reactiveElementVersions ??= []).push("2.0.4");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e5ed8027d647799b$var$n = globalThis, $e5ed8027d647799b$var$c = $e5ed8027d647799b$var$n.trustedTypes, $e5ed8027d647799b$var$h = $e5ed8027d647799b$var$c ? $e5ed8027d647799b$var$c.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $e5ed8027d647799b$var$f = "$lit$", $e5ed8027d647799b$var$v = `lit$${Math.random().toFixed(9).slice(2)}$`, $e5ed8027d647799b$var$m = "?" + $e5ed8027d647799b$var$v, $e5ed8027d647799b$var$_ = `<${$e5ed8027d647799b$var$m}>`, $e5ed8027d647799b$var$w = document, $e5ed8027d647799b$var$lt = ()=>$e5ed8027d647799b$var$w.createComment(""), $e5ed8027d647799b$var$st = (t)=>null === t || "object" != typeof t && "function" != typeof t, $e5ed8027d647799b$var$g = Array.isArray, $e5ed8027d647799b$var$$ = (t)=>$e5ed8027d647799b$var$g(t) || "function" == typeof t?.[Symbol.iterator], $e5ed8027d647799b$var$x = "[ 	\n\f\r]", $e5ed8027d647799b$var$T = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $e5ed8027d647799b$var$E = /-->/g, $e5ed8027d647799b$var$k = />/g, $e5ed8027d647799b$var$O = RegExp(`>|${$e5ed8027d647799b$var$x}(?:([^\\s"'>=/]+)(${$e5ed8027d647799b$var$x}*=${$e5ed8027d647799b$var$x}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $e5ed8027d647799b$var$S = /'/g, $e5ed8027d647799b$var$j = /"/g, $e5ed8027d647799b$var$M = /^(?:script|style|textarea|title)$/i, $e5ed8027d647799b$var$P = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $e5ed8027d647799b$export$c0bb0b647f701bb5 = $e5ed8027d647799b$var$P(1), $e5ed8027d647799b$export$7ed1367e7fa1ad68 = $e5ed8027d647799b$var$P(2), $e5ed8027d647799b$export$47d5b44d225be5b4 = $e5ed8027d647799b$var$P(3), $e5ed8027d647799b$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $e5ed8027d647799b$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $e5ed8027d647799b$var$V = new WeakMap, $e5ed8027d647799b$var$I = $e5ed8027d647799b$var$w.createTreeWalker($e5ed8027d647799b$var$w, 129);
function $e5ed8027d647799b$var$N(t, i) {
    if (!$e5ed8027d647799b$var$g(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $e5ed8027d647799b$var$h ? $e5ed8027d647799b$var$h.createHTML(i) : i;
}
const $e5ed8027d647799b$var$U = (t, i)=>{
    const s = t.length - 1, e = [];
    let h, o = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", n = $e5ed8027d647799b$var$T;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let r, l, c = -1, a = 0;
        for(; a < s.length && (n.lastIndex = a, l = n.exec(s), null !== l);)a = n.lastIndex, n === $e5ed8027d647799b$var$T ? "!--" === l[1] ? n = $e5ed8027d647799b$var$E : void 0 !== l[1] ? n = $e5ed8027d647799b$var$k : void 0 !== l[2] ? ($e5ed8027d647799b$var$M.test(l[2]) && (h = RegExp("</" + l[2], "g")), n = $e5ed8027d647799b$var$O) : void 0 !== l[3] && (n = $e5ed8027d647799b$var$O) : n === $e5ed8027d647799b$var$O ? ">" === l[0] ? (n = h ?? $e5ed8027d647799b$var$T, c = -1) : void 0 === l[1] ? c = -2 : (c = n.lastIndex - l[2].length, r = l[1], n = void 0 === l[3] ? $e5ed8027d647799b$var$O : '"' === l[3] ? $e5ed8027d647799b$var$j : $e5ed8027d647799b$var$S) : n === $e5ed8027d647799b$var$j || n === $e5ed8027d647799b$var$S ? n = $e5ed8027d647799b$var$O : n === $e5ed8027d647799b$var$E || n === $e5ed8027d647799b$var$k ? n = $e5ed8027d647799b$var$T : (n = $e5ed8027d647799b$var$O, h = void 0);
        const u = n === $e5ed8027d647799b$var$O && t[i + 1].startsWith("/>") ? " " : "";
        o += n === $e5ed8027d647799b$var$T ? s + $e5ed8027d647799b$var$_ : c >= 0 ? (e.push(r), s.slice(0, c) + $e5ed8027d647799b$var$f + s.slice(c) + $e5ed8027d647799b$var$v + u) : s + $e5ed8027d647799b$var$v + (-2 === c ? i : u);
    }
    return [
        $e5ed8027d647799b$var$N(t, o + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        e
    ];
};
class $e5ed8027d647799b$var$B {
    constructor({ strings: t, _$litType$: i }, s){
        let e;
        this.parts = [];
        let h = 0, o = 0;
        const n = t.length - 1, r = this.parts, [l, a] = $e5ed8027d647799b$var$U(t, i);
        if (this.el = $e5ed8027d647799b$var$B.createElement(l, s), $e5ed8027d647799b$var$I.currentNode = this.el.content, 2 === i || 3 === i) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (e = $e5ed8027d647799b$var$I.nextNode()) && r.length < n;){
            if (1 === e.nodeType) {
                if (e.hasAttributes()) for (const t of e.getAttributeNames())if (t.endsWith($e5ed8027d647799b$var$f)) {
                    const i = a[o++], s = e.getAttribute(t).split($e5ed8027d647799b$var$v), n = /([.?@])?(.*)/.exec(i);
                    r.push({
                        type: 1,
                        index: h,
                        name: n[2],
                        strings: s,
                        ctor: "." === n[1] ? $e5ed8027d647799b$var$Y : "?" === n[1] ? $e5ed8027d647799b$var$Z : "@" === n[1] ? $e5ed8027d647799b$var$q : $e5ed8027d647799b$var$G
                    }), e.removeAttribute(t);
                } else t.startsWith($e5ed8027d647799b$var$v) && (r.push({
                    type: 6,
                    index: h
                }), e.removeAttribute(t));
                if ($e5ed8027d647799b$var$M.test(e.tagName)) {
                    const t = e.textContent.split($e5ed8027d647799b$var$v), i = t.length - 1;
                    if (i > 0) {
                        e.textContent = $e5ed8027d647799b$var$c ? $e5ed8027d647799b$var$c.emptyScript : "";
                        for(let s = 0; s < i; s++)e.append(t[s], $e5ed8027d647799b$var$lt()), $e5ed8027d647799b$var$I.nextNode(), r.push({
                            type: 2,
                            index: ++h
                        });
                        e.append(t[i], $e5ed8027d647799b$var$lt());
                    }
                }
            } else if (8 === e.nodeType) {
                if (e.data === $e5ed8027d647799b$var$m) r.push({
                    type: 2,
                    index: h
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = e.data.indexOf($e5ed8027d647799b$var$v, t + 1));)r.push({
                        type: 7,
                        index: h
                    }), t += $e5ed8027d647799b$var$v.length - 1;
                }
            }
            h++;
        }
    }
    static createElement(t, i) {
        const s = $e5ed8027d647799b$var$w.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $e5ed8027d647799b$var$z(t, i, s = t, e) {
    if (i === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s.o?.[e] : s.l;
    const o = $e5ed8027d647799b$var$st(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s.o ??= [])[e] = h : s.l = h), void 0 !== h && (i = $e5ed8027d647799b$var$z(t, h._$AS(t, i.values), h, e)), i;
}
class $e5ed8027d647799b$var$F {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $e5ed8027d647799b$var$w).importNode(i, !0);
        $e5ed8027d647799b$var$I.currentNode = e;
        let h = $e5ed8027d647799b$var$I.nextNode(), o = 0, n = 0, r = s[0];
        for(; void 0 !== r;){
            if (o === r.index) {
                let i;
                2 === r.type ? i = new $e5ed8027d647799b$var$et(h, h.nextSibling, this, t) : 1 === r.type ? i = new r.ctor(h, r.name, r.strings, this, t) : 6 === r.type && (i = new $e5ed8027d647799b$var$K(h, this, t)), this._$AV.push(i), r = s[++n];
            }
            o !== r?.index && (h = $e5ed8027d647799b$var$I.nextNode(), o++);
        }
        return $e5ed8027d647799b$var$I.currentNode = $e5ed8027d647799b$var$w, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $e5ed8027d647799b$var$et {
    get _$AU() {
        return this._$AM?._$AU ?? this.v;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this.v = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $e5ed8027d647799b$var$z(this, t, i), $e5ed8027d647799b$var$st(t) ? t === $e5ed8027d647799b$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && this._$AR(), this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee) : t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $e5ed8027d647799b$var$$(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && $e5ed8027d647799b$var$st(this._$AH) ? this._$AA.nextSibling.data = t : this.T($e5ed8027d647799b$var$w.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $e5ed8027d647799b$var$B.createElement($e5ed8027d647799b$var$N(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $e5ed8027d647799b$var$F(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $e5ed8027d647799b$var$V.get(t.strings);
        return void 0 === i && $e5ed8027d647799b$var$V.set(t.strings, i = new $e5ed8027d647799b$var$B(t)), i;
    }
    k(t) {
        $e5ed8027d647799b$var$g(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $e5ed8027d647799b$var$et(this.O($e5ed8027d647799b$var$lt()), this.O($e5ed8027d647799b$var$lt()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this.v = t, this._$AP?.(t));
    }
}
class $e5ed8027d647799b$var$G {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $e5ed8027d647799b$var$z(this, t, i, 0), o = !$e5ed8027d647799b$var$st(t) || t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $e5ed8027d647799b$var$z(this, e[s + n], i, n), r === $e5ed8027d647799b$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$e5ed8027d647799b$var$st(r) || r !== this._$AH[n], r === $e5ed8027d647799b$export$45b790e32b2810ee ? t = $e5ed8027d647799b$export$45b790e32b2810ee : t !== $e5ed8027d647799b$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $e5ed8027d647799b$var$Y extends $e5ed8027d647799b$var$G {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $e5ed8027d647799b$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $e5ed8027d647799b$var$Z extends $e5ed8027d647799b$var$G {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $e5ed8027d647799b$export$45b790e32b2810ee);
    }
}
class $e5ed8027d647799b$var$q extends $e5ed8027d647799b$var$G {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $e5ed8027d647799b$var$z(this, t, i, 0) ?? $e5ed8027d647799b$export$45b790e32b2810ee) === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $e5ed8027d647799b$export$45b790e32b2810ee && s !== $e5ed8027d647799b$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $e5ed8027d647799b$export$45b790e32b2810ee && (s === $e5ed8027d647799b$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $e5ed8027d647799b$var$K {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $e5ed8027d647799b$var$z(this, t);
    }
}
const $e5ed8027d647799b$export$8613d1ca9052b22e = {
    M: $e5ed8027d647799b$var$f,
    P: $e5ed8027d647799b$var$v,
    A: $e5ed8027d647799b$var$m,
    C: 1,
    L: $e5ed8027d647799b$var$U,
    R: $e5ed8027d647799b$var$F,
    D: $e5ed8027d647799b$var$$,
    V: $e5ed8027d647799b$var$z,
    I: $e5ed8027d647799b$var$et,
    H: $e5ed8027d647799b$var$G,
    N: $e5ed8027d647799b$var$Z,
    U: $e5ed8027d647799b$var$q,
    B: $e5ed8027d647799b$var$Y,
    F: $e5ed8027d647799b$var$K
}, $e5ed8027d647799b$var$Re = $e5ed8027d647799b$var$n.litHtmlPolyfillSupport;
$e5ed8027d647799b$var$Re?.($e5ed8027d647799b$var$B, $e5ed8027d647799b$var$et), ($e5ed8027d647799b$var$n.litHtmlVersions ??= []).push("3.2.0");
const $e5ed8027d647799b$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $e5ed8027d647799b$var$et(i.insertBefore($e5ed8027d647799b$var$lt(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $fe586ba0757c37f7$export$3f2f9f5909897157 extends (0, $27fcf98b67c2a783$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this.o = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const e = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this.o = (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)(e, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this.o?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this.o?.setConnected(!1);
    }
    render() {
        return 0, $e5ed8027d647799b$export$9c068ae9cc5db4e8;
    }
}
$fe586ba0757c37f7$export$3f2f9f5909897157._$litElement$ = !0, $fe586ba0757c37f7$export$3f2f9f5909897157["finalized"] = !0, globalThis.litElementHydrateSupport?.({
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$var$f = globalThis.litElementPolyfillSupport;
$fe586ba0757c37f7$var$f?.({
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$export$f5c524615a7708d6 = {
    _$AK: (t, e, s)=>{
        t._$AK(e, s);
    },
    _$AL: (t)=>t._$AL
};
(globalThis.litElementVersions ??= []).push("4.1.0");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $650ed036964a13b8$export$6acf61af03e62db = !1;





let $96b2d36fd178e822$var$currentComponent = {};
function $96b2d36fd178e822$export$f36d6a7a5c09a23e({ tag: tag, component: CustomFuntionalComponent }) {
    class CustomComponent extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
        constructor(){
            super();
            this.hookIndex = 0;
            this.hooks = {};
        }
        render() {
            // get all attributes
            const attributes = Array.from(this.attributes).reduce((acc, attr)=>{
                acc[attr.name] = attr.value;
                return acc;
            }, {});
            this.hookIndex = 0;
            $96b2d36fd178e822$var$currentComponent = this;
            const functionalComponent = ()=>CustomFuntionalComponent({
                    ...attributes,
                    children: this.innerHTML
                });
            $96b2d36fd178e822$var$currentComponent = null;
            return functionalComponent();
        }
    }
    window.customElements.define(tag, CustomComponent);
}
function $96b2d36fd178e822$export$60241385465d0a34(initialState) {
    const component = $96b2d36fd178e822$var$currentComponent;
    const hookIndex = component.hookIndex++;
    const hookName = `hook-${hookIndex}`;
    if (!component.hooks[hookName]) component.hooks[hookName] = initialState;
    const setState = (newState)=>{
        const value = typeof newState === "function" ? newState(component.hooks[hookName]) : newState;
        component.hooks[hookName] = value;
        component.requestUpdate();
    };
    return [
        component.hooks[hookName],
        setState
    ];
}
function $96b2d36fd178e822$export$6d9c69b0de29b591(effect, dependencies) {
    const component = $96b2d36fd178e822$var$currentComponent;
    const hookIndex = component.hookIndex++;
    const hookName = `hook-${hookIndex}`;
    const prevDeps = component.hooks[hookName]?.dependencies;
    const hasChanged = !prevDeps || dependencies.some((dep, i)=>dep !== prevDeps[i]);
    if (hasChanged) {
        if (component.hooks[hookName]?.cleanup) component.hooks[hookName].cleanup();
        const cleanup = effect();
        component.hooks[hookName] = {
            dependencies: dependencies,
            cleanup: cleanup
        };
    }
    component.addController({
        hostDisconnected () {
            if (component.hooks[hookName]?.cleanup) component.hooks[hookName].cleanup();
        }
    });
}
function $96b2d36fd178e822$export$1538c33de8887b59(calculation, dependencies) {
    const component = $96b2d36fd178e822$var$currentComponent;
    const hookIndex = component.hookIndex++;
    const hookName = `hook-${hookIndex}`;
    const prevDeps = component.hooks[hookName]?.dependencies;
    const hasChanged = !prevDeps || dependencies.some((dep, i)=>dep !== prevDeps[i]);
    if (hasChanged) component.hooks[hookName] = {
        value: calculation(),
        dependencies: dependencies
    };
    return component.hooks[hookName].value;
}


const $43eb7b9bae1b879f$var$Todo = ()=>{
    const [todos, setTodos] = (0, $96b2d36fd178e822$export$60241385465d0a34)([]);
    const [inputValue, setInputValue] = (0, $96b2d36fd178e822$export$60241385465d0a34)("");
    (0, $96b2d36fd178e822$export$6d9c69b0de29b591)(()=>{
        console.log("Todo mounted");
        return ()=>{
            console.log("Todo unmounted");
        };
    }, []);
    (0, $96b2d36fd178e822$export$6d9c69b0de29b591)(()=>{
        console.log("Todos changed");
    }, [
        todos
    ]);
    const numberOfTodoItems = (0, $96b2d36fd178e822$export$1538c33de8887b59)(()=>{
        console.log("memo calculation triggered");
        return todos.length;
    }, [
        todos
    ]);
    const addTodo = ()=>{
        setTodos([
            ...todos,
            inputValue
        ]);
        setInputValue("");
    };
    const removeTodo = (index)=>{
        setTodos(todos.filter((_, i)=>i !== index));
    };
    return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
        <div>
            <h1>Todo App</h1>
            <input type="text" placeholder="Add todo" .value="${inputValue}" @input="${(e)=>setInputValue(e.target.value)}" />
            <button @click="${addTodo}">
                Add
            </button>
            <p>
                Number of todo items: ${numberOfTodoItems}
            </p>
            <ul>
                ${todos.map((todo, index)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                    <li key="${index}">
                        ${todo}
                        <button @click="${()=>removeTodo(index)}">
                            Remove
                        </button>
                    </li>
                `)}
            </ul>
        </div>
    `;
};
(0, $96b2d36fd178e822$export$f36d6a7a5c09a23e)({
    tag: "todo-app",
    component: $43eb7b9bae1b879f$var$Todo
});


//# sourceMappingURL=index.611ce525.js.map
